const hidden = (hiddenIds, id) => _.contains(hiddenIds, id);

export function addBaseJourneySpecialFields(receiver, hiddenIds, options = {}) {
  if (options.processed) {
    receiver.unshift({
      id: -4,
      title: '节点时限',
      type: 'HoldField::Yaw::AssignmentDurationThreshold',
      settings: { input_type: 'datetime-local' },
      _hidden: hidden(hiddenIds, -4)
    });
    receiver.unshift({
      id: -9,
      title: '节点状态',
      type: 'HoldField::Yaw::AssignmentStatus',
      _hidden: hidden(hiddenIds, -9)
    });
    if (options.enableIdentityVerify) {
      receiver.unshift({
        id: -11,
        title: '身份证号（实名核身）',
        type: 'HoldField::Iauth::IdentityID',
        _hidden: hidden(hiddenIds, -11)
      });
      receiver.unshift({
        id: -10,
        title: '姓名（实名核身）',
        type: 'HoldField::Iauth::IdentityName',
        _hidden: hidden(hiddenIds, -10)
      });
    }
    receiver.unshift({
      id: -13,
      title: '发起人',
      type: 'HoldField::Yaw::JourneyProposer',
      _hidden: hidden(hiddenIds, -13)
    });
  }
  receiver.unshift({
    id: -8,
    title: '当前节点',
    type: 'HoldField::Yaw::VertexName',
    _hidden: hidden(hiddenIds, -8)
  });
  receiver.unshift({
    id: -25,
    title: '流程自定义编号',
    type: 'HoldField::Yaw::JourneyCustomSn',
    _hidden: hidden(hiddenIds, -25)
  });
  receiver.unshift({
    id: -5,
    title: '流程编号',
    type: 'HoldField::Yaw::JourneySn',
    _hidden: hidden(hiddenIds, -5)
  });
  receiver.push({
    id: -6,
    title: '流程状态',
    type: 'HoldField::Yaw::JourneyStatus',
    _hidden: hidden(hiddenIds, -6),
    addition: {
      id: -7,
      title: '流程时限',
      type: 'HoldField::Yaw::JourneyDurationThreshold'
    }
  });
  receiver.push({
    id: -12,
    title: '发起时间',
    type: 'HoldField::Yaw::JourneyCreatedAt',
    settings: { input_type: 'datetime-local' },
    _hidden: hidden(hiddenIds, -12)
  });
  return receiver;
}

export function addAdminJourneySpecialFields(receiver, hiddenIds) {
  receiver.unshift({
    id: -8,
    title: '当前节点',
    type: 'HoldField::Yaw::VertexName',
    _hidden: hidden(hiddenIds, -8),
    addition: {
      id: -4,
      title: '节点时限',
      type: 'HoldField::Yaw::AssignmentDurationThreshold'
    }
  });
  receiver.unshift({
    id: -13,
    title: '发起人',
    type: 'HoldField::Yaw::JourneyProposer',
    _hidden: hidden(hiddenIds, -13)
  });
  receiver.unshift({
    id: -19,
    title: '发起人识别码',
    type: 'HoldField::Yaw::JourneyProposerIdentifier',
    _hidden: hidden(hiddenIds, -19)
  });
  receiver.unshift({
    id: -25,
    title: '流程自定义编号',
    type: 'HoldField::Yaw::JourneyCustomSn',
    _hidden: hidden(hiddenIds, -25)
  });
  receiver.unshift({
    id: -5,
    title: '流程编号',
    type: 'HoldField::Yaw::JourneySn',
    _hidden: hidden(hiddenIds, -5)
  });
  receiver.push({
    id: -6,
    title: '流程状态',
    type: 'HoldField::Yaw::JourneyStatus',
    _hidden: hidden(hiddenIds, -6),
    addition: {
      id: -7,
      title: '流程时限',
      type: 'HoldField::Yaw::JourneyDurationThreshold'
    }
  });
  receiver.push({
    id: -12,
    title: '发起时间',
    type: 'HoldField::Yaw::JourneyCreatedAt',
    settings: { input_type: 'datetime-local' },
    _hidden: hidden(hiddenIds, -12)
  });
  return receiver;
}

export function addResponseSpecialFields(receiver, hiddenIds) {
  const hideUnlessConfigured = (id) => (hiddenIds.length ? hidden(hiddenIds, id) : true);
  receiver.unshift({
    id: -3,
    title: '所在组织',
    type: 'Field::HoldOrganization',
    _hidden: hideUnlessConfigured(-3)
  });
  receiver.unshift({
    id: -18,
    title: '识别码',
    type: 'Field::HoldUserIdentifier',
    _hidden: hideUnlessConfigured(-18)
  });
  receiver.unshift({
    id: -20,
    title: '手机号',
    type: 'Field::HoldUserPhone',
    _hidden: hideUnlessConfigured(-20)
  });
  receiver.unshift({
    id: -2,
    title: '填写用户',
    type: 'Field::HoldUser',
    _hidden: hidden(hiddenIds, -2)
  });
  receiver.push({
    id: -1,
    title: '填写时间',
    type: 'Field::HoldCreatedAt',
    settings: { input_type: 'datetime-local' },
    _hidden: hidden(hiddenIds, -1)
  });
  return receiver;
}

const tableSpecialFields = {
  members_table_special_fields: [
    {
      id: -1,
      title: '姓名',
      type: 'Field::UserItem',
      _hidden: false,
      _has_search: true,
    },
    {
      id: -4,
      title: '手机号码',
      type: 'Field::TextField',
      _hidden: false,
      _has_search: true,
    },
    {
      id: -16,
      title: '成员标签',
      type: 'Field::Tags',
      _hidden: false,
      _has_search: false,
    },
  ],
};

export default tableSpecialFields;
